//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
let d=[[[1,"Depth",0,"Expression",0]],[[["point","isKeyPoint"],"AppendPoint",{},2,0],[[],"Close",{R_:{isClosed:''}},0,0],[[],"DeleteAll",{},0,0],[[],"DeleteLastKeyPoint",{},0,0],[["numPoints"],"GetPoints",{R_:{points:""}},0,0],[["direction"],"SetPlaneNormal",{},1,0],[["vector"],"Translate",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.BoundaryDefinitionBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.BoundaryDefinitionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;